// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3VxSF","alert":"SettungsInbox_alert__3EKhn"};